import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import BellIcon from '@heroicons/react/outline/BellIcon';
import clsx from 'clsx';
import { useUpdateMemberPostNotificationSettings } from '@tribeplatform/react-sdk/hooks';
import { Button } from '@tribeplatform/react-ui-kit/Button';
import { useLogin } from '../../common/hooks/useLogin';
import { useI18n } from '../../i18n';
export const FollowAction = ({ post, showIcon = true, showText = true, }) => {
    var _a;
    const intl = useI18n();
    const { isLoggedIn, showLogin } = useLogin();
    const { isLoading, mutate: updateMemberPostNotificationSettings } = useUpdateMemberPostNotificationSettings();
    const isFollowed = (_a = post === null || post === void 0 ? void 0 : post.authMemberProps) === null || _a === void 0 ? void 0 : _a.memberPostNotificationSettingsEnabled;
    const handleClick = useCallback(e => {
        if (!isLoggedIn) {
            e.preventDefault();
            return showLogin();
        }
        if (isLoading) {
            return;
        }
        updateMemberPostNotificationSettings({
            input: {
                enabled: !isFollowed,
            },
            postId: post === null || post === void 0 ? void 0 : post.id,
        });
    }, [
        isFollowed,
        isLoading,
        post === null || post === void 0 ? void 0 : post.id,
        updateMemberPostNotificationSettings,
        isLoggedIn,
        showLogin,
    ]);
    const leadingIcon = isFollowed ? (_jsx(BellIcon, { className: "w-6 h-6 -rotate-12 shrink-0" }, void 0)) : (_jsx(BellIcon, { className: "w-6 h-6 transition-transform group-hover:-rotate-12 shrink-0" }, void 0));
    return (_jsx("div", { className: "flex-1 flex min-w-0 h-full", children: _jsx(Button, { variant: "outline", className: clsx('group select-none', isFollowed && 'bg-surface-subdued hover:bg-surface-hovered'), size: "md", fullWidth: true, leadingIcon: showIcon ? leadingIcon : null, onClick: handleClick, children: showText && (_jsx("div", { className: "truncate", children: isFollowed
                    ? intl.$t({
                        id: 'Generics.Following',
                        defaultMessage: 'Following',
                    })
                    : intl.$t({
                        id: 'Generics.Follow',
                        defaultMessage: 'Follow',
                    }) }, void 0)) }, void 0) }, void 0));
};
//# sourceMappingURL=FollowAction.js.map